import MobileQuestionPage from './mobile-question-page';

export default MobileQuestionPage;
